WiseMetering.Views.InfraspeakConfigurationsTable = WiseMetering.Views.TableIndex.extend({
    icon: 'integrations',
    name: () => 'navigator',

    createTable: function() {
        this.collection = this.model.configurations();

        this.table = new WiseMetering.Views.Table({
            id: 'configurations',
            collection: this.collection,
            disableSelect: !WiseMetering.currentUser.isSuperUser(),
            modelSerializer: model => {
                let
                    color = 'orange',
                    state = model.get('state');

                if (state === 'active') {
                    color = 'green';
                }

                return {
                    site: WiseMetering.zones.sites().get(model.get('site_id')).get('name'),
                    site_reference_name: model.get('site_reference_name') || '',
                    id: model.id,
                    name: model.get('name'),
                    state: { color, state },
                    updated_at: WiseMetering.utils.formatDate(model.get('updated_at'))
                };
            },
            columns: {
                state: {
                    mRender: ({ color, state }) => JST['templates/ui/components/circle']({
                        color: WiseMetering.SemaphorColors[color],
                        title: state.capitalize()
                    }),
                    sWidth: '20px'
                },
                name: i18next.t('common.name'),
                site: i18next.t('glossary.site'),
                site_reference_name: i18next.t('integrations.infraspeak_site'),
                updated_at: i18next.t('glossary.last_change')
            },
            toolbar_actions: {
                new: {
                    label: i18next.t('ui.actions.new'),
                    permission: 'superuser',
                    view_call: () => new WiseMetering.Views.NewInfraspeakConfiguration({
                        collection: WiseMetering.integrationConfigurations,
                        model: new WiseMetering.Model.IntegrationConfiguration({ license_id: this.model.id })
                    })
                },
                edit: {
                    label: i18next.t('ui.actions.edit'),
                    permission: 'superuser',
                    view_call: model => new WiseMetering.Views.EditInfraspeakConfiguration({ model })
                },
                show: {
                    label: i18next.t('ui.actions.show'),
                    view_call: model => new WiseMetering.Views.ShowInfraspeakConfiguration({ model })
                },
                disable: {
                    enabled: model => model.get('state') === 'active',
                    icon: 'disable',
                    label: i18next.t('ui.actions.disable'),
                    permission: 'superuser',
                    view_call: model => new WiseMetering.Views.DisableIntegrationConfiguration({ model })
                },
                enable: {
                    enabled: model => model.get('state') !== 'active',
                    icon: 'enable',
                    label: i18next.t('ui.actions.enable'),
                    permission: 'superuser',
                    view_call: model => new WiseMetering.Views.EnableIntegrationConfiguration({ model })
                },
                delete: {
                    permission: 'superuser',
                    view_call: model => new WiseMetering.Views.Modal.DestroyExtraConfirmation({
                        model,
                        title: () => i18next.t('modal.title.integration_configurations.destroy')
                    })
                }
            }
        });

        $(this.body.el).html(this.table.el);
    },

    onClose: function() {
        this.stopListening(WiseMetering.integrationConfigurations);

        if (this.table && this.table.remove && typeof (this.table.remove) === 'function') {
            this.table.remove();
        }
    },

    onShow: function() {
        this.listenTo(WiseMetering.integrationConfigurations, 'remove add change', this.createTable.bind(this));

        this.createTable();
    }
});
